export default "__VITE_ASSET__DcnCe7MW__"